import { trigger, transition, style, animate, state } from "@angular/animations";

export const slideDown = trigger(
  'slideDown',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateY(-100%)' }),
        animate('.3s ease-out',
          style({ transform: 'translateY(0)' })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateY(0)', position: 'absolute' }),
        animate('.3s ease-in',
          style({ transform: 'translateY(-100%)', position: 'absolute' }),
        )
      ]
    )
  ]
)

export const slideFromRight = trigger(
  'slideFromRight',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateX(100%)', opacity: 0, }),
        animate('.3s ease-out',
          style({ transform: 'translateX(0)', opacity: 1 })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateX(0)', opacity: 1, }),
        animate('.3s ease-in',
          style({ transform: 'translateX(100%)', opacity: 0 }),
        )
      ]
    )
  ]
)

export const slideUp = trigger(
  'slideUp',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateY(100%)' }),
        animate('.3s ease-out',
          style({ transform: 'translateY(0)' })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateY(0)', position: 'absolute' }),
        animate('.3s ease-in',
          style({ transform: 'translateY(100%)', position: 'absolute' }),
        )
      ]
    )
  ]
)

export const fade = trigger(
  'fade',
  [
    transition(
      ':enter',
      [
        style({ opacity: '0' }),
        animate('.075s ease-out',
          style({ opacity: '1' }),
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ opacity: '1' }),
        animate('.075s ease-in',
          style({ opacity: '0' }),
        )
      ]
    )
  ]
);

export const transformToSize = trigger(
  'transformToSize',
  [
    transition(
      ':enter',
      [
        style({ transform: 'scale(0) translateY(-50%)' }),
        animate('.075s ease-out',
          style({ transform: 'scale(1) translateY(-50%)' }))
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'scale(1) translateY(-50%)' }),
        animate('.075s ease-in',
          style({ transform: 'scale(0) translateY(-50%)' }))
      ]
    )
  ]
);

export const openClose = trigger(
  'openClose',
  [
    transition(
      ':enter', [
      style({ transform: 'scale(1, 0)', 'transform-origin': 'top' }),
      animate('.3s ease-out',
        style({ transform: 'scale(1, 1)', 'transform-origin': 'top' })
      )]
    ),
    transition(
      ':leave', [
      style({ transform: 'scale(1, 1)', 'transform-origin': 'top' }),
      animate('.3s ease-out',
        style({ transform: 'scale(1, 0)', 'transform-origin': 'top' })
      )]
    ),
  ])


export const slideX = trigger(
  'slideX',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateX(-100%)' }),
        animate('.3s ease-out',
          style({ transform: 'translateX(0)' })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateX(0)' }),
        animate('.3s ease-in',
          style({ transform: 'translateX(100%)' }),
        )
      ]
    )
  ]
)

export const slideY = trigger(
  'slideY',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateY(-100%)' }),
        animate('.3s ease-out',
          style({ transform: 'translateY(0)' })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateY(0)' }),
        animate('.3s ease-in',
          style({ transform: 'translateY(100%)' }),
        )
      ]
    )
  ]
)

export const expandAndRetract = trigger(
  'expandAndRetract', [
  state('true', style({
    height: '*',
  })),
  state('false', style({
    overflow: 'hidden',
    height: '0px',
  })),
  transition('true => false', animate('150ms ease-out')),
  transition('false => true', animate('150ms ease-out'))
]);

export const slideLeftAndFade = trigger(
  'slideLeftAndFade',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateX(50%)', opacity: 0, }),
        animate('.300s ease-out',
          style({ transform: 'translateX(0)', opacity: 1 })
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ opacity: 1 }),
        animate('.075s ease-out',
          style({ opacity: 0 }),
        )
      ]
    )
  ]
);
